// Load TaxiServiceId enum BEFORE any imports to avoid Jest module loading issues when mocks are active
const { TaxiServiceId } = require('./Redux/ConditionEntities');

import { VehicleOption, ConditionLookupTables, MaxiTaxiLookUpType, ApiVehicleOption } from './Redux/ConditionEntities'
import appstore from '../../appStore';
import { ConvertToServiceInfo } from './VehicleToServiceTranslater';
import { Vehicle } from '../../Services/MakeBookingContracts';
import services, { ServiceInfo } from '../../utils/service-vehicles/ServiceMetadata';
import { GetMyBrand } from '../../Config/MyAppConfig';
import { Brand } from '../../Config/Entities/Brand';

/**
 * Process raw vehicle types (Ids) from Global Booker and map them to vehicle details.
 * With initial loading of vehicles from the API, vehicleTypes parameter is null so the default list for the brand is displayed.
 */
export function MakeVehicleLookupFromApiData(vehicleTypes: number[] | null): ConditionLookupTables {
    const ConditionList: VehicleOption[] = [];
    const MaxiTaxiLookUp: MaxiTaxiLookUpType = {};

    const allVehicles = appstore.getState().condition.AllVehicles;

    let vehiclesToDisplay: Vehicle[] = [];

    if (!vehicleTypes) {
        vehiclesToDisplay = allVehicles.filter(i => i.IsInDefaultList);
    } else {
        for (let vehicle of allVehicles) {
            if (vehicleTypes.some(i => i == vehicle.GlobalBookerVehicleId)) {
                vehiclesToDisplay.push(vehicle);
            }
        }
    }

    for (var vehicle of vehiclesToDisplay) {

        // Condition is dummy here, and useless for GB implementation, maybe this implementation is not ideal?
        const vehicleOption: ApiVehicleOption = {
            ApiVersion: 2,
            ApiId: vehicle.GlobalBookerVehicleId,
            Name: vehicle.Name,
            MaxSeat: 0,
            Description: vehicle.ShortDescription
        };

        const service = ConvertToServiceInfo(vehicle);

        ConditionList.push({ Service: service, ApiVehicle: vehicleOption });        
    }

    // Add "Next Available" option
    // V2 always uses generic "any" (anySA doesn't exist in V2)
    const nextAvailable = services.any;
    
    // Add NextAvailable to the beginning of the list (unless SilverService brand)
    const brand = GetMyBrand();
    if (brand !== Brand.SilverService) {
        ConditionList.unshift(MakeVehicleFromService(nextAvailable));
    }

    return { ConditionList: ConditionList, MaxiTaxiLookUp: MaxiTaxiLookUp };
};

/**
 * Helper function to create a VehicleOption from a ServiceInfo
 * For V2, Next Available always uses TaxiServiceId.NextAvailable
 */
function MakeVehicleFromService(service: ServiceInfo): VehicleOption {
    const apiVehicle: ApiVehicleOption = {
        ApiVersion: 2,
        ApiId: TaxiServiceId.NextAvailable,
        Name: "NextAvailable",
        MaxSeat: 4,
        Description: `Next Available`
    };
    
    return { Service: service, ApiVehicle: apiVehicle };
}
